/* Divine Importers refresh, additions of 6 October 2026. No dependencies; works alongside dv.js.
   - Saved list: count on the header heart, a popup when something is saved or removed (with Undo), a mini list on hover.
   - Listings: grid/list view (remembered), filter bar pinned while scrolling, next products load as you scroll
     (four batches, then the button), back to top, and Back returns you to the same place.
   - Approved accounts: prices on the saved list. */
(function () {
  var KEY = 'dv-saved', VIEW = 'dv-view', POS = 'dv-list-pos';
  var body = document.body;
  var savedUrl = body.getAttribute('data-dv-saved-url') || '/collections/all?view=saved';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function find(list, h) { for (var i = 0; i < list.length; i++) if (list[i].h === h) return list[i]; return null; }
  var closeSvg = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  /* ---------- saved list: count, popup, mini list ---------- */
  function count() {
    var n = load().length;
    document.querySelectorAll('[data-dv-saved-count]').forEach(function (b) { b.textContent = n > 99 ? '99+' : String(n); b.hidden = n === 0; });
    document.querySelectorAll('.dv-saved-link').forEach(function (a) { a.setAttribute('aria-label', n ? 'Saved products (' + n + ')' : 'Saved products'); });
  }
  var toast = null, toastT = null, lastRemoved = null;
  function hideToast() { if (toast) toast.classList.remove('on'); }
  function hideSoon(ms) { clearTimeout(toastT); toastT = setTimeout(hideToast, ms); }
  function makeToast() {
    toast = document.createElement('div'); toast.className = 'svt'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
    body.appendChild(toast);
    toast.addEventListener('mouseenter', function () { clearTimeout(toastT); });
    toast.addEventListener('mouseleave', function () { hideSoon(2500); });
    toast.addEventListener('click', function (e) {
      if (e.target.closest('[data-svt-close]')) { e.preventDefault(); hideToast(); }
      else if (e.target.closest('[data-svt-undo]')) { e.preventDefault(); undo(); }
    });
  }
  function showToast(item, added, n) {
    if (!toast) makeToast();
    var pic = item.i ? '<img src="' + esc(item.i) + '" alt="">' : '<span class="ph"></span>';
    toast.innerHTML = pic + '<div><span class="h">' + (added ? 'Saved to your list' : 'Removed from your list') + '</span>' +
      '<span class="n">' + esc(item.t) + '</span><span class="c">' + n + (n === 1 ? ' product' : ' products') + ' on your list</span></div>' +
      '<button class="x" type="button" data-svt-close aria-label="Close">' + closeSvg + '</button>' +
      '<div class="bts">' + (added ? '<a class="dbtn" href="' + esc(savedUrl) + '">View your list</a>'
        : '<button class="ub" type="button" data-svt-undo>Undo</button><a class="lnk" href="' + esc(savedUrl) + '">View your list</a>') + '</div>';
    if (window.innerWidth > 760) {
      var top = 16, hdr = document.querySelector('.hdr'), bar = document.querySelector('[data-dv-filters]');
      if (hdr) top = Math.max(top, hdr.getBoundingClientRect().bottom + 10);
      if (bar && bar.getBoundingClientRect().top <= 1) top = Math.max(top, bar.getBoundingClientRect().bottom + 10); // pinned at the top
      toast.style.top = Math.round(top) + 'px';
    } else { toast.style.top = ''; }
    void toast.offsetWidth;
    toast.classList.add('on');
    hideSoon(added ? 4500 : 6500);
  }
  function undo() {
    if (!lastRemoved) return;
    var x = lastRemoved; lastRemoved = null;
    // Re-add through dv.js, exactly as if the heart had been pressed again.
    var b = document.createElement('button'); b.type = 'button'; b.hidden = true; b.setAttribute('data-dv-save', '');
    [['handle', x.h], ['title', x.t], ['vendor', x.v], ['code', x.c], ['pack', x.k], ['img', x.i]].forEach(function (a) { b.setAttribute('data-' + a[0], a[1] || ''); });
    body.appendChild(b); b.click(); b.remove();
  }
  var prev = load();
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-dv-save]'), clr = e.target.closest('[data-dv-clear-saved]');
    if (!s && !clr) return;
    setTimeout(function () { // dv.js has updated the list by now
      var cur = load();
      if (s) {
        var h = s.getAttribute('data-handle'), was = find(prev, h), now = find(cur, h);
        if (now && !was) showToast(now, true, cur.length);
        else if (was && !now) { lastRemoved = was; showToast(was, false, cur.length); }
      }
      prev = cur; count(); renderMini();
    }, 0);
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { prev = load(); count(); renderMini(); } });

  var sw = document.querySelector('[data-dv-saved-wrap]'), mini = null, miniT = null;
  function renderMini() {
    if (!mini) return;
    var list = load(), n = list.length, rows = list.slice(-5).reverse();
    mini.innerHTML = '<p class="k">Your list' + (n ? ' (' + n + ')' : '') + '</p>' + (n ? '<ul>' + rows.map(function (x) {
      return '<li><a href="/products/' + esc(x.h) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy">' : '<span class="ph"></span>') +
        '<span><span class="v">' + esc(x.v) + '</span><span class="t">' + esc(x.t) + '</span></span></a></li>';
    }).join('') + '</ul><a class="go" href="' + esc(savedUrl) + '">' + (n > 5 ? 'See all ' + n + ' on your list' : 'View your list') + '</a>'
      : '<p class="em">Nothing saved yet. Press the heart on any product to keep it here, then send the list to the office.</p>');
  }
  if (sw && window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 761px)').matches) {
    mini = document.createElement('div'); mini.className = 'svm'; mini.hidden = true; sw.appendChild(mini);
    sw.addEventListener('mouseenter', function () { clearTimeout(miniT); hideToast(); renderMini(); mini.hidden = false; });
    sw.addEventListener('mouseleave', function () { miniT = setTimeout(function () { mini.hidden = true; }, 220); });
  }
  count();

  /* ---------- prices on the saved list (approved accounts only) ---------- */
  if (body.hasAttribute('data-dv-prices')) {
    var sg = document.querySelector('[data-dv-saved-page] [data-grid]');
    if (sg) {
      var cache = {}, fmt = function (p) { try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(p / 100); } catch (e) { return '£' + (p / 100).toFixed(2); } };
      var addPrices = function () {
        sg.querySelectorAll('.lc a.pc').forEach(function (a) {
          if (a.querySelector('.pp')) return;
          var h = (a.getAttribute('href') || '').split('/products/')[1]; if (!h) return;
          var put = function (txt) {
            if (a.querySelector('.pp')) return;
            var sp = document.createElement('span'); sp.className = 'pp'; sp.textContent = txt;
            if (txt.indexOf('£') !== -1) { var sm = document.createElement('small'); sm.textContent = ' ex VAT'; sp.appendChild(sm); }
            a.appendChild(sp);
          };
          if (cache[h]) { put(cache[h]); return; }
          fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
            if (!p) return;
            cache[h] = p.price > 0 ? (p.price_varies ? 'From ' : '') + fmt(p.price) : 'Price on request';
            put(cache[h]);
          }).catch(function () {});
        });
      };
      new MutationObserver(addPrices).observe(sg, { childList: true });
      addPrices();
    }
  }

  /* ---------- grid or list view ---------- */
  var grid = document.querySelector('[data-dv-grid]');
  function setView(v, keep) {
    if (!grid) return;
    grid.classList.toggle('lv', v === 'list');
    document.querySelectorAll('[data-dv-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-dv-view') === v ? 'true' : 'false'); });
    if (keep) { try { localStorage.setItem(VIEW, v); } catch (e) {} }
  }
  if (grid) setView(grid.classList.contains('lv') ? 'list' : 'grid', false);
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dv-view]'); if (!b) return;
    e.preventDefault(); setView(b.getAttribute('data-dv-view'), true);
  });

  /* ---------- floating buttons, bottom left (the live chat sits bottom right) ---------- */
  var fab = document.createElement('div'); fab.className = 'dvfab'; body.appendChild(fab);
  var btt = document.createElement('button'); btt.type = 'button'; btt.className = 'btt'; btt.hidden = true; btt.setAttribute('aria-label', 'Back to top'); btt.title = 'Back to top';
  btt.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
  fab.appendChild(btt);
  btt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' }); });

  /* ---------- filter bar: pinned while scrolling (desktop), "Filter & sort" button (phone) ---------- */
  var fb = document.querySelector('[data-dv-filters]'), ffb = null;
  if (fb && 'IntersectionObserver' in window) {
    var sen = document.createElement('div'); sen.setAttribute('aria-hidden', 'true'); sen.style.cssText = 'height:1px;margin-top:-1px';
    fb.parentNode.insertBefore(sen, fb);
    var act = fb.querySelectorAll('.dd.act').length;
    ffb = document.createElement('button'); ffb.type = 'button'; ffb.className = 'ffb'; ffb.hidden = true;
    ffb.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4"/></svg>Filter &amp; sort' + (act ? ' <b>' + act + '</b>' : '');
    fab.appendChild(ffb);
    ffb.addEventListener('click', function () { fb.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); });
    new IntersectionObserver(function (es) {
      var past = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      fb.classList.toggle('stuck', past); ffb.hidden = !past;
    }).observe(sen);
  }

  /* ---------- listings: load the next products as you scroll ---------- */
  var foot = document.querySelector('[data-dv-foot]');
  var AUTO = 3, auto = 0, busy = false, pages = 1, force = 0, restoreY = null;
  function moreLink() { return foot && foot.querySelector('[data-dv-more]'); }
  function check() {
    if (!foot || busy) return;
    var m = moreLink();
    if (!m) { finish(); return; }
    if (force > 0) { busy = true; force--; m.click(); return; }
    finish();
    if (auto >= AUTO) return;
    if (foot.getBoundingClientRect().top > window.innerHeight + 700) return;
    busy = true; auto++; m.click();
  }
  function finish() {
    if (restoreY !== null && force <= 0 && !busy) { var y = restoreY; restoreY = null; window.scrollTo(0, y); }
  }
  if (grid && foot) {
    new MutationObserver(function () {
      var m = moreLink();
      if (busy && (!m || m.textContent.indexOf('Loading') === -1)) { busy = false; pages++; requestAnimationFrame(check); }
    }).observe(foot, { childList: true, subtree: true, characterData: true });
    // Coming back with the Back button: load the same batches again and return to the same place.
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      var saved = JSON.parse(sessionStorage.getItem(POS) || 'null');
      if (nav && nav.type === 'back_forward' && saved && saved.u === location.pathname + location.search) {
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        force = Math.max(0, (saved.n || 1) - 1); restoreY = saved.y || 0;
      }
    } catch (e) {}
    window.addEventListener('pagehide', function () {
      try { sessionStorage.setItem(POS, JSON.stringify({ u: location.pathname + location.search, n: pages, y: window.pageYOffset })); } catch (e) {}
    });
    setTimeout(check, 300);
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var up = window.pageYOffset > window.innerHeight * 1.5; if (btt.hidden === up) btt.hidden = !up;
      check();
    });
  }, { passive: true });
})();
